<template>
  <div id="guidePage">
    <div class="header-nav flex-align">
      <img src="~@/assets/images/login-logo-easyloon.png">
      <div class="nav-right flex-align">
        <global-outlined class="ic-lanage" />
        <language-selector style="padding-left: 10px; background: #fff;" />
      </div>
    </div>
    <div class="body-info">
      <div class="body-box">
        <div class="body-left">
          <div class="top-title">{{ $t("pages_merchant_107") }}</div>
          <div class="top-explain">{{ $t("pages_merchant_110") }}</div>
          <div class="timeline_css">
            <div style="width: 80%;display: flex;flex-direction: column;align-items: center;">
              <a-steps :current="3">
                <a-step title="第一步" description="填写公司信息">
                  <template #icon>
                    <div class="stepIcon">1</div>
                  </template>
                </a-step>
                <a-step title="第二步" description="上传公司资料">
                  <template #icon>
                    <div class="stepIcon">2</div>
                  </template>
                </a-step>
                <a-step title="第三步" description="填写业务信息">
                  <template #icon>
                    <div class="stepIcon">3</div>
                  </template>
                </a-step>
              </a-steps>
            </div>
          </div>
        </div>
        <div class="body-right">
          <div class="title">{{ $t("pages_merchant_118") }}</div>
          <div class="areaBox">
            <div class="area">
              <div class="area-right">
                <div class="right-title">{{ $t("pages_merchant_119") }}</div>
                <div class="right-explain">{{ $t("pages_merchant_120") }}</div>
                <div class="right-box">
                  <img class="right-icon" src="~@/assets/images/template.png">
                  <a class="right-down" :href="require('../../assets/files/yingYeZhiZhao.png')" target="_blank">{{
                    $t("pages_merchant_046") }}</a>
                </div>
              </div>
            </div>
            <div class="area">
              <div class="area-right">
                <div class="right-title">{{ $t("pages_merchant_121") }}</div>
                <div class="right-explain">{{ $t("pages_merchant_122") }}</div>
                <div class="right-explain">{{ $t("pages_merchant_123") }}</div>
                <div class="right-explain">{{ $t("pages_merchant_124") }}</div>
                <div class="right-box">
                  <img class="right-icon" src="~@/assets/images/template.png">
                  <a class="right-down" :href="require('./../../assets/files/shenFenZheng.png')" target="_blank">{{
                    $t("pages_merchant_046") }}</a>
                </div>
              </div>
            </div>
            <div class="area">
              <div class="area-right">
                <div class="right-title">{{ $t("pages_merchant_125") }}</div>
                <div class="right-explain">{{ $t("pages_merchant_126") }}</div>
                <div class="right-box">
                  <img class="right-icon" src="~@/assets/images/template.png">
                  <a v-if="language === 'en'" class="right-down" @click="downloadTemplate('boardResolution')">{{
                    $t("pages_merchant_046") }}</a>
                  <a v-else class="right-down" @click="downloadTemplate('powerAttorney')">{{ $t("pages_merchant_046")
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a-button
          type="primary"
          style="margin-top: 36px;width: 168px;height: 33px;border-radius: 30px;line-height: 24px;"
          @click="$router.push('/merchant_info')"
        >{{
          $t("pages_merchant_117") }}</a-button>
      </div>
    </div>
    <img class="guide_bottom" src="~@/assets/images/guide_page_bottom.png">
  </div>
</template>
<script>
import { reactive, toRefs, inject } from 'vue'
import { _user } from '@/api'
import LangSelector from '@/components/lang-sel'
export default {
  name: 'GuidePage',
  components: {
    'language-selector': LangSelector
  },
  setup() {
    const state = reactive({
      themeData: inject('$themeData'),
      language: localStorage.getItem('locale-language') || 'zh'
    })

    const downloadTemplate = async (name) => {
      const res = await _user.exportMerchantTemplate({ name })
      if (res.data.succ) window.open(res.data.data)
    }

    return {
      downloadTemplate,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
#guidePage {
  text-align: left;
  color: #000;
  position: relative;
  height: 100vh;

  .header-nav {
    height: 60px;
    padding: 0 30px;
    margin-bottom: 4px;
    position: absolute;
    width: 100%;
    z-index: 5;
    background: #ffffff;

    // box-shadow: 0 0 6px 0 #d9d9d9;
    img {
      width: 150px;
    }

    .nav-right {
      margin-left: auto;
      cursor: pointer;

      .ic-lanage {
        color: @main-color;
        font-size: 24px;
      }

      .text {
        margin-left: 8px;
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  .body-info {
    display: flex;
    justify-content: center;
    padding-top: 56px;
    position: relative;
    z-index: 2;
    // background: #FFEECC;
    background: rgba(255, 238, 204, 0.5);
    height: 100%;

    .body-box {
      width: 1088px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .body-left {
        width: 100%;
        margin-top: 160px;
        display: flex;
        align-items: center;
        flex-direction: column;

        .timeline_css {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          margin-top: 40px;
          margin-bottom: 54px;

          .stepIcon {
            background: rgb(186, 132, 56);
            border-radius: 50%;
            width: 22px;
            height: 22px;
            font-size: 16px;
            color: rgba(255, 255, 255, 0.9);
            text-align: center;
            line-height: 22px;
            margin-top: 4px;
          }
        }

        .timeline_css :deep(.ant-steps-item-description) {
          color: rgba(0, 0, 0, 0.9) !important;
          font-size: 14px !important;
        }

        .top-title {
          margin-top: 30px;
          font-size: 32px;
          font-weight: 500;
          color: #BA8438;
          text-align: center;
        }

        .top-explain {
          color: #495060;
          margin-top: 12px;
          font-size: 14px;
          background: rgba(183, 121, 57, 0.1);
          color: rgba(0, 0, 0, 0.6);
          border-radius: 8px;
          width: 390px;
          height: 32px;
          line-height: 32px;
          text-align: center;
        }

        .timeline-title {
          font-weight: 600;
          margin-bottom: 7px;
        }
      }

      .body-right {
        width: 100%;
        box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
        border-radius: 6px;
        padding: 36px;
        background: rgba(255, 255, 255, 0.8);

        .title {
          font-size: 24px;
          font-weight: 600;
          text-align: center;
        }

        .areaBox {
          display: flex;
          justify-content: space-around;

          .area {
            margin-top: 64px;
            display: flex;

            .area-left {
              img {
                width: 95px;
              }
            }

            .area-right {
              width: 256px;
              min-height: 162px;
              position: relative;

              .right-title {
                font-weight: 600;
                font-size: 16px;
              }

              .right-explain {
                color: #495060;
                margin-top: 5px;
                font-size: 14px;
              }

              .right-box {
                position: absolute;
                bottom: 0px;
                right: 0px;

                .right-icon {
                  width: 14px;
                  height: 14px;
                  margin-bottom: 3px;
                  margin-right: 2px;
                }

                .right-down {
                  display: inline-block;
                  margin-top: 5px;
                  font-weight: 600;
                  color: #BA8438;
                }
              }

            }
          }
        }
      }
    }
  }

  .guide_bottom {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 1;
  }
}

@media (max-width: 1600px) {
  #guidePage {
    .body-info {
      .body-box {
        scale: 0.8;

        .body-left {
          width: 100%;
          margin-top: 10px;
          display: flex;
          align-items: center;
          flex-direction: column;
        }
      }
    }
  }
}
</style>
